// Site-level config: navigation, images, SEO defaults.

const IMG =
  "https://static.prod-images.emergentagent.com/jobs/6bde3535-ff26-4cc0-99ec-7279be72715c/images/";

export const images = {
  heroPhone: IMG + "c3967a5028dcd31bfa9fa06f0d9e99cce9d23ffb30dc9c54211bb68561163293.jpeg",
  storeInterior: IMG + "cc986c93c3728678f3cc9140825e3ccd9ddd5a7f95bcc64829e4264521e9fecc.jpeg",
  repairScene: IMG + "536bdfa4c1b8ad27248b69c68e88df6747a26db763ff592cee85174f542fe008.jpeg",
  phoneBlue: IMG + "bcbbcdf4e168093d55ba32a3bba33f06ccd2287dd11b851543af74d823a03d56.jpeg",
  phonePink: IMG + "0b85da5d88aa4ba50613a13d10b3824fd797786450c0c89b7a6920622b6d700d.jpeg",
  phoneSilver: IMG + "99e8241775c84bd8949749bae9431cb75892ab0d98d927d28a0883f0c081eed1.jpeg",
  phoneBlack: IMG + "53e4d83952389ed9e49f5719144660b80129c62266ff79d6b0e88b2c9a7bf9a4.jpeg",
  phoneGreen: IMG + "2d2d86cb79c29b96b7446875a2791f5ddfa04db80c39328cb540085e7d3ce404.jpeg",
  phoneGold: IMG + "f9950a0d7bcca96e725441ec9d80bea67ea023b103e55e225dc56490ced4c17e.jpeg",
};

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "New Phones", to: "/phones?type=new" },
  { label: "Used Phones", to: "/phones?type=used" },
  { label: "Repair", to: "/repair" },
  { label: "Sell Your Phone", to: "/sell-your-phone" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const siteUrl = "https://rohini-repair-shop.preview.emergentagent.com";
